import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { StatsBar } from "@/components/StatsBar";
import { Awards } from "@/components/Awards";
import { About } from "@/components/About";
import { StartHere } from "@/components/StartHere";
import { LeadForm } from "@/components/LeadForm";
import { FinalCTA } from "@/components/FinalCTA";
import { MobileBar } from "@/components/MobileBar";
import { PopupForm } from "@/components/PopupForm";
import { Toaster } from "sonner";

export default function Landing() {
  return (
    <div className="bg-[#0A0A0A] pb-16 lg:pb-0">
      <Toaster position="top-center" richColors />
      <PopupForm />
      <Header />
      <Hero />
      <StatsBar />
      <Awards />
      <About />
      <StartHere />
      <LeadForm />
      <FinalCTA />
      <MobileBar />
    </div>
  );
}
